import React, {Component} from "react";
import {Nav} from "react-bootstrap";
import {Modal} from "../../../../../components";
import NoteListModalV2 from "../notes/NoteListModalV2";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default class ReferralAppendixTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            notesModalVisible: false
        }
    }

    openNoteListModal = () => {
        this.setState({notesModalVisible: true});
    }

    closeNoteListModal = () => {
        this.setState({notesModalVisible: false});
        this.props.onNoteClose();
    }

    render() {
        const notes = this.props.referral.notes || [];
        const notesCount = notes.filter(i => i.isActive).length;

        return (
            <>
                <Nav.Item>
                    <Nav.Link onClick={this.openNoteListModal} style={{cursor: 'pointer'}}>
                        <FontAwesomeIcon icon={["fas", "sticky-note"]} size="sm" className="mr-1"/>
                        Notes ({notesCount})
                    </Nav.Link>
                </Nav.Item>
                {this.state.notesModalVisible &&
                    <Modal
                        visible={this.state.notesModalVisible}
                        header="Notes"
                        closeAction={this.closeNoteListModal}
                        contentStyle={{minWidth: 600, minHeight: 400}}
                    >
                        <NoteListModalV2
                            referralId={this.props.referral.id}
                            readOnly={this.props.readOnly}
                        />
                    </Modal>
                }
            </>
        );
    }
}
